import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../clients';
import { turnSchema } from '../types';

export const receiveTurn = createReceive('turn', zodContract(turnSchema));
